export const ENTERPRISE_OVERVIEW_URL = 'https://www.udacity.com/enterprise/overview';
export const FALLBACK_MONTHLY_PRICE = '$249';

export function buildEmployerEmailTemplate(monthlyPrice = FALLBACK_MONTHLY_PRICE) {
  return `
Hi [manager name],

I'd like to enroll in a program called [program name] on the professional education platform Udacity. Programs at Udacity consist of a high-quality, meticulously designed curriculum, built in collaboration with companies like Google, Facebook, Amazon, Adobe, and Microsoft.

If you’d like to review what I will learn in [program name], please take a look here: [link to course]

Udacity’s learning subscription is unique because I’ll learn via hands-on projects that allow me to apply my new skills in the workplace immediately. I’ll also have access to a mentor network comprised of industry experts I can get feedback from throughout my learning journey.

This new knowledge will help our team by [list reasons]

A Udacity subscription costs ${monthlyPrice} per month. This gets me access to every program on their platform from schools such as Artificial Intelligence, Data Science, and Programming. I will be able to expand my knowledge in multiple areas beneficial to the team through continuous education.

What are your thoughts?

Thanks,
[Your Name]

P.S. Udacity has business plans that allow for entire teams to upskill at once. It might make sense for us to sign up for a plan like this. You can learn more here: ${ENTERPRISE_OVERVIEW_URL}
  `;
}

export function buildBusinessEmailTemplate() {
  return `
Hi [manager name],

I’ve been researching professional education platforms for our team, and would like to share information with you about the best one I found, Udacity. Programs at Udacity consist of a high-quality, meticulously designed curriculum, built in collaboration with companies like Google, Facebook, Amazon, Adobe, and Microsoft.

Here are links to a few of the programs I think would have the biggest impact for us [link to program pages].

Udacity’s learning subscription is unique because the team would learn via hands-on projects that would allow us to apply our new skills in the workplace immediately. We’d also have access to a mentor network comprised of industry experts we could get feedback from throughout our learning journeys.

Providing a subscription to our team will help us by [list reasons]

A Udacity subscription gets the team access to every program on their platform from schools such as Artificial Intelligence, Data Science, and Programming. We will be able to expand our knowledge in multiple areas through continuous education.

You can learn more about how Udacity helps entire teams upskill and why this would be great for our development here: ${ENTERPRISE_OVERVIEW_URL}

What are your thoughts?

Thanks,
[Your Name]
  `;
}
